export function BalanceIcon() {
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
      className='neededStroke'
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.004"
        d="M7.168 11.24v1.354c0 1.146-1.067 2.073-2.38 2.073-1.314 0-2.387-.927-2.387-2.073V11.24c0 1.147 1.067 1.96 2.387 1.96 1.313 0 2.38-.82 2.38-1.96z"
      ></path>
      <path
      className='neededStroke'
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.004"
        d="M7.167 9.407c0 .333-.094.64-.254.906-.393.647-1.2 1.054-2.133 1.054s-1.74-.414-2.133-1.054a1.75 1.75 0 01-.254-.906c0-.574.267-1.087.694-1.46.433-.38 1.026-.607 1.686-.607.66 0 1.254.233 1.687.607.44.366.707.886.707 1.46z"
      ></path>
      <path
      className='neededStroke'
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.004"
        d="M7.168 9.407v1.833c0 1.147-1.067 1.96-2.38 1.96-1.314 0-2.387-.82-2.387-1.96V9.407c0-1.147 1.067-2.074 2.387-2.074.66 0 1.253.234 1.686.607.427.373.694.893.694 1.467zM14.667 7.313v1.374a.684.684 0 01-.667.68h-1.307c-.72 0-1.38-.527-1.44-1.247-.04-.42.12-.813.4-1.087.247-.253.587-.4.96-.4H14a.685.685 0 01.667.68z"
      ></path>
      <path
        className='neededStroke'
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.004"
        d="M1.333 7V5.667c0-1.814 1.094-3.08 2.794-3.294.173-.026.353-.04.54-.04h6c.173 0 .34.007.5.034 1.72.2 2.833 1.473 2.833 3.3v.966h-1.387c-.373 0-.713.147-.96.4-.28.274-.44.667-.4 1.087.06.72.72 1.247 1.44 1.247H14v.966c0 2-1.333 3.334-3.333 3.334H9"
      ></path>
    </svg>
    );
  }